import clientConfig from '@/modules/client/config'
import request from '@/modules/base/util/request'

/*
 * Actions
 */
const UPDATE_CLIENT_DATA = 'orgamax/client/detail/UPDATE_CLIENT_DATA'
const START_FETCHING_CLIENT_DATA = 'orgamax/client/detail/START_FETCHING_CLIENT_DATA'
const ERROR_FETCHING_CLIENT_DATA = 'orgamax/client/detail/ERROR_FETCHING_CLIENT_DATA'

/*
 * Reducer
 */
const initialState = {
  data: {},
  isLoading: false,
  errorOccurred: false,
}

export default function reducer(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case UPDATE_CLIENT_DATA:
      return { ...state, isLoading: false, data }

    case START_FETCHING_CLIENT_DATA:
      return { ...state, isLoading: true }

    case ERROR_FETCHING_CLIENT_DATA:
      return { ...state, errorOccurred: true }

    default:
      return state
  }
}

export const updateData = (data) => {
  return {
    type: UPDATE_CLIENT_DATA,
    data,
  }
}

const startFetchingStatsData = () => {
  return {
    type: START_FETCHING_CLIENT_DATA,
  }
}

const errorFetchingClientData = () => {
  return {
    type: ERROR_FETCHING_CLIENT_DATA,
  }
}

export const resetClientData = () => {
  return async dispatch =>
    dispatch(updateData(initialState.data))
}

export const fetchClientData = (id, cb) => {
  return async dispatch => {
    dispatch(startFetchingStatsData())

    try {
      const { body: { data } } = await request(`${clientConfig.resourceUrl}/${id}`, {
        auth: true,
        isConcurrent: true,
      })
      dispatch(updateData(data))
      cb && cb(data)
    } catch {
      dispatch(errorFetchingClientData())
    }
  }
}
